import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row, message, Modal } from "antd";
import axios from "axios";
import "./Pages.css";
import TituloForm from '../components/TituloForm';
import TituloLiquidarForm from '../components/TituloLiquidarForm';
import TituloFiltroForm from '../components/TituloFiltroForm';
import ContratosFatForm from '../components/ContratosFatForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import Colors from '../utils/Colors';

const { Column } = Table;
const ButtonGroup = Button.Group;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    vlrAberto: 0,
    vlrPago: 0,
    vlrTotal: 0,
    qtdeTit: 0,

    formVisivel: false,
    formLiqVisivel: false,
    formFatVisivel: false,
    formFiltroVisivel: false,

    registroSelecionado: [],
    registroParc: [],

    filtros: {
      tipoTela: 'CTRPGTO',
      buscaOrdem: { campo: 'pes_nome', ordem: 'ASC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaNumero: '',
      buscaDescricao: '',
      buscaTipo: { key: 'X', },
      buscaSituacao: { key: 'X', },
      buscaPlanoCta: { key: '0' },
      buscaCtaCorrente: { key: '0' },
      buscaTipoDoc: { key: '0' },
      buscaContrato: { key: '0' },
      buscaUsuario: { key: '0', },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      },
        this.getListaRegistros
      )
    }
  }

  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, vlrAberto: 0, vlrPago: 0, vlrTotal: 0, qtdeTit: 0 });
    const { pagina, limite } = this.state;

    const { buscaOrdem, buscaDataIni, buscaDataFim, buscaNumero, buscaControle, buscaSituacao, buscaContrato, buscaUsuario } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    // console.log('getListaRegistros', buscaContrato.key)

    axios
      .get('/contratos/mensalidades', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          controle: buscaControle,
          numero: buscaNumero,
          situacao: buscaSituacao.key,
          tit_idf_contrato: buscaContrato.key,
          usuario: buscaUsuario.key,
          dataIni,
          dataFim,
          tipoTela: 'PAGTO',
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.dados;

        // console.log('getListaRegistros: ', response.data);

        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          vlrAberto: response.data.vlrAberto,
          vlrPago: response.data.vlrPago,
          vlrTotal: response.data.vlrTotal,
          qtdeTit: response.data.qtdeTit,
        });

      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };


  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    // console.log('Registro gravar: ', registro);
    let request;
    if (registro.tit_idf) { //editar      
      request = axios.put(`/titulos/update/${registro.tit_idf}`, registro);
    } else { // cadastrar
      request = axios.post(`/titulos/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Registro gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        if (error.response.status === 412) {
          Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }
      })
  }

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        visualizar: false,
        tipoTela: 'CONTR',
        dados: {
          tit_idf: 0,
          tit_controle: 0,
          tit_numero: 0,
          tit_tipo: { key: 'E', label: 'Entrada', },
          tit_data_emissao: moment().format('DD/MM/YYYY'),
          tit_descricao: '',
          tit_idf_contrato: this.state.filtros.buscaContrato.key,
          tit_pessoa: {
            key: String(this.state.filtros.buscaContrato.pessoa),
            label: '',
          },
          tit_valor: 0,
          tit_tipo_doc: {
            key: String(this.state.usuario.par_doc_padrao),
            label: this.state.usuario.td_descricao,
          },
          tit_cond_pagto: {
            key: String(this.state.usuario.par_cond_pagto_padrao),
            label: this.state.usuario.td_descricao,
            qtdeParc: this.state.usuario.cp_qtde_parc,
            parcAVista: this.state.usuario.cp_parc_avista,
          },
          tit_plano_conta: {
            key: String(this.state.usuario.par_pc_contrato),
            label: '',
          },
          tit_cta_corrente: {
            key: String(this.state.usuario.par_cta_corrente_padrao),
            label: this.state.usuario.cc_descricao,
          },

          listaParcelas: [],
        }
      }
    })
  };

  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/titulos/show/${registro.tit_idf}`)
      .then(response => {
        const { data } = response;

        // console.log('parcelas: ', data);

        data.dados.tit_pessoa = {
          key: String(data.dados.tit_pessoa),
          label: data.dados.pes_nome,
        }
        data.dados.tit_tipo_doc = {
          key: String(data.listaParcelas[0].tparc_tipo_doc),
          label: data.listaParcelas[0].td_descricao,
        }
        data.dados.tit_cond_pagto = {
          key: String(data.dados.tit_cond_pagto),
          label: data.dados.cp_descricao,
          qtdeParc: data.dados.cp_qtde_parc,
          parcAVista: data.dados.cp_parc_avista,
        }
        data.dados.tit_plano_conta = {
          key: String(data.dados.tit_plano_conta),
          label: data.dados.pc_descricao,
        }
        data.dados.tit_cta_corrente = {
          key: String(data.listaParcelas[0].tparc_conta_corrente),
          label: data.listaParcelas[0].cc_descricao,
        }
        data.dados.tit_data_emissao = moment(data.dados.tit_data_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.tit_tipo = {
          key: data.dados.pc_tipo,
          label: data.dados.pc_tipo === 'E' ? 'Entrada' : 'Saída',
        }

        this.setState({
          formVisivel: true,
          registroSelecionado: {
            ...data,
            visualizar,
            tipoTela: 'CONTR',
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onDuplicarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/titulos/show/${registro.tit_idf}`)
      .then(response => {
        const { data } = response;

        // console.log('parcelas: ', data);

        data.dados.tit_pessoa = {
          key: String(data.dados.tit_pessoa),
          label: data.dados.pes_nome,
        }
        data.dados.tit_tipo_doc = {
          key: String(data.listaParcelas[0].tparc_tipo_doc),
          label: data.listaParcelas[0].td_descricao,
        }
        data.dados.tit_cond_pagto = {
          key: String(data.dados.tit_cond_pagto),
          label: data.dados.cp_descricao,
          qtdeParc: data.dados.cp_qtde_parc,
          parcAVista: data.dados.cp_parc_avista,
        }
        data.dados.tit_plano_conta = {
          key: String(data.dados.tit_plano_conta),
          label: data.dados.pc_descricao,
        }
        data.dados.tit_cta_corrente = {
          key: String(data.listaParcelas[0].tparc_conta_corrente),
          label: data.listaParcelas[0].cc_descricao,
        }
        data.dados.tit_data_emissao = moment(data.dados.tit_data_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.tit_tipo = {
          key: data.dados.pc_tipo,
          label: data.dados.pc_tipo === 'E' ? 'Entrada' : 'Saída',
        }

        data.dados.tit_idf = 0;
        data.dados.tit_controle = 0;
        data.dados.tit_numero = 0;

        this.setState({
          formVisivel: true,
          registroSelecionado: {
            ...data,
            visualizar,
            tipoTela: '',
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/titulos/delete/${registro.tit_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.tit_idf === registro.tit_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
            } else {
              Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
            }

          })
      }
    })
  };





  onLiquidarClick = () => {
    this.setState({
      formLiqVisivel: false,
    }, this.getListaRegistros)
  };

  onCancelarLiqClick = () => {
    this.setState({
      formLiqVisivel: false
    }, this.getListaRegistros)
  }

  onVisualizarClick = registro => {
    this.setState({ carregando: true });
    axios
      .get('/titulos/showParcela', {
        params: {
          idf: registro.tit_idf,
          parc: registro.tparc_parcela,
        }
      })
      .then(response => {
        const { data } = response;

        data.tparc_tipo_doc = {
          key: String(data.tparc_tipo_doc),
          label: data.td_descricao,
          // key: String(this.state.usuario.par_doc_padrao),
          // label: this.state.usuario.td_descricao,
        }
        data.tparc_conta_corrente = {
          key: String(data.tparc_conta_corrente),
          label: data.cc_descricao,
          // key: String(this.state.usuario.par_cta_corrente_padrao),
          // label: this.state.usuario.cc_descricao,
        }

        data.pgto_data = moment().format('DD/MM/YYYY');
        data.tipoTela = 'LIQ';

        this.setState({
          formLiqVisivel: true,
          registroParc: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };



  onAbrirFatClick = () => {
    this.setState({
      formFatVisivel: true,
    })
  };

  onFatClick = (filtros) => {
    this.setState({
      formFatVisivel: false,
    },
      this.getListaRegistros
    )
  };

  onCancelarFatClick = () => {
    this.setState({
      formFatVisivel: false,
    })
  };




  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaNumero: String(this.state.filtros.buscaNumero),
        buscaControle: String(this.state.filtros.buscaControle),
        buscaDescricao: String(this.state.filtros.buscaDescricao),
        buscaTipo: this.state.filtros.buscaTipo,
        buscaSituacao: this.state.filtros.buscaSituacao,
        buscaPlanoCta: this.state.filtros.buscaPlanoCta,
        buscaCtaCorrente: this.state.filtros.buscaCtaCorrente,
        buscaTipoDoc: this.state.filtros.buscaTipoDoc,
        buscaContrato: this.state.filtros.buscaContrato,
        buscaUsuario: this.state.filtros.buscaUsuario,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { filtros } = this.state;
    filtros[id] = value;
    this.setState({
      [id]: value,
      pagina: 1
    },
      this.getListaRegistros
    );
  };


  renderSituacao = (tit_situacao) => {
    if (tit_situacao === 'A') {
      return (
        <span>ABERTO</span>
      );
    } else if (tit_situacao === 'P') {
      return (
        <span>PAGO</span>
      );
    } else if (tit_situacao === 'F') {
      return (
        <span>FATURADO</span>
      );
    } else if (tit_situacao === 'C') {
      return (
        <span>CANCELADO</span>
      );
    }
  };


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }


  renderAcoes = (registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('ContratosFaturamentoPage', 'editar') ? (
          <Tooltip title={registro.situacao_parcela === 'PAGO' ? 'Abrir Parcela' : 'Liquidar Parcela'}>
            <Button type="primary" size="small" onClick={() => this.onVisualizarClick(registro)} icon="check" placement="topLeft" style={{ backgroundColor: Colors.primaryLight, borderColor: Colors.primaryLight }} />
          </Tooltip>
        ) : null}
        {getTemPermissao('ContratosFaturamentoPage', 'editar') ? (
          <Tooltip title="Editar">
            <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('ContratosFaturamentoPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button type="danger" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : null}
        {getTemPermissao('ContratosFaturamentoPage', 'novo') ? (
          <Tooltip title="Duplicar">
            <Button type="ghost" size="small" onClick={() => this.onDuplicarClick(registro, false)} icon="folder-add" />
          </Tooltip>
        ) : null}
      </ButtonGroup>
    );
  };

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderValorRest = (vlr, registro) => {
    return (
      <span> {numeral(parseFloat(registro.tparc_valor - vlr)).format('0,000.00')} </span>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros
    )
  })


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };





  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formLiqVisivel, formFiltroVisivel, formVisivel, formFatVisivel, registroSelecionado, registroParc,
      salvando, filtros, total, pagina, limite } = this.state;
    const { } = this.state.filtros;

    // console.log('ContratosFaturamentoPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Faturamento dos Contratos</span>
        <div className="divider-page" />

        <Row>
          <div className="pageFiltro" style={{ height: 50 }}>
            <Col xs={24} >

              <Row>
                <Col xs={24} sm={24} style={{ marginTop: 10 }} className="camposEspacoDireita">

                  {getTemPermissao('ContratosFaturamentoPage', 'novo') ? (
                    <Col xs={2} style={{ width: 110, marginTop: 4 }}>
                      <Button
                        type="primary"
                        onClick={this.onAdicionarClick}
                        className="botao-primary"
                      >
                        Novo Pagto
                      </Button>
                    </Col>
                  ) : null}

                  {getTemPermissao('ContratosFaturamentoPage', 'novo') ? (
                    <Col xs={2} style={{ width: 110, marginTop: 4 }}>
                      <Button
                        type="primary"
                        onClick={this.onAbrirFatClick}
                        className="botao-primary"
                      >
                        Faturar
                      </Button>
                    </Col>
                  ) : null}

                  <Col xs={2} style={{ width: 110, marginLeft: 10, marginTop: 4 }}>
                    <Button
                      type="primary"
                      onClick={this.onAbrirFiltroClick}
                      className="botao-primary"
                      style={{ marginRight: 15 }}
                    >
                      Filtrar
                    </Button>
                  </Col>


                  <Col xs={24} md={14} style={{ height: 65, padding: 5, marginTop: -20 }}>
                    <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            Qtde
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.state.qtdeTit}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                    <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            Abertos
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrAberto)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                    <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            Pagos
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrPago)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                    <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            Valor Total
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrTotal)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                  </Col>
                </Col>
              </Row>
            </Col>



            <TituloFiltroForm
              visivel={formFiltroVisivel}
              onFiltrarClick={this.onFiltrarClick}
              onCancelarFiltroClick={this.onCancelarFiltroClick}
              filtros={filtros}
            />

            <ContratosFatForm
              visivel={formFatVisivel}
              onFatClick={this.onFatClick}
              onCancelarFatClick={this.onCancelarFatClick}
              filtros={filtros}
            />

            <TituloForm
              visivel={formVisivel}
              onSalvarClick={this.onSalvarClick}
              onCancelarClick={this.onCancelarClick}
              carregando={salvando}
              registroSelecionado={registroSelecionado}
            />

            <TituloLiquidarForm
              visivel={formLiqVisivel}
              onLiquidarClick={this.onLiquidarClick}
              onCancelarLiqClick={this.onCancelarLiqClick}
              registroParc={registroParc}
            />

          </div>
        </Row>

        <Row>
          <div style={{ marginTop: 10 }}>
            <Table
              pagination={{
                total: total,
                pageSize: limite,
                current: pagina,
                pageSizeOptions: ['10', '20', '30', '40'],
                showSizeChanger: true,
              }}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.tit_idf + '_' + registro.tparc_parcela)}
            >
              <Column
                key="pes_nome"
                dataIndex="pes_nome"
                title={this.renderTitulo("Cliente")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={200}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tit_descricao"
                dataIndex="tit_descricao"
                title={this.renderTitulo("Descrição")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={120}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="contr_numero"
                dataIndex="contr_numero"
                title={this.renderTitulo("Contrato")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={80}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="td_descricao"
                dataIndex="td_descricao"
                title={this.renderTitulo("Documento")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={80}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tparc_data_parcela"
                dataIndex="tparc_data_parcela"
                title={this.renderTitulo("Vencimento")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderData}
                width={120}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="pgto_data"
                dataIndex="pgto_data"
                title={this.renderTitulo("Data Pagto")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderData}
                width={120}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="tparc_valor"
                dataIndex="tparc_valor"
                title={this.renderTitulo("Valor Parc")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="pgto_vlr_pago"
                dataIndex="pgto_vlr_pago"
                title={this.renderTitulo("Valor Pagto")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="pgto_vlr_pago"
                dataIndex="pgto_vlr_pago"
                title={this.renderTitulo("Valor Restante")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValorRest}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="situacao_parcela"
                dataIndex="situacao_parcela"
                title={this.renderTitulo("Situação")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={100}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="acoes"
                title={this.renderTitulo(".")}
                render={this.renderAcoes}
                width={140}
                align="center"
                className="listaCadastro"
              />
            </Table>
          </div>
        </Row>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/ContratosFaturamentoPage.js